
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5349_37451)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_5349_37451)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 21.5a6 6 0 0112 0h2a8 8 0 10-16 0h2zm9-14a3 3 0 11-6 0 3 3 0 016 0zm2 0a5 5 0 11-10 0 5 5 0 0110 0z","fill":"#161616","fill-opacity":".72"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5349_37451"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_5349_37451"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    